import { codecs, createPath } from "@pomle/paths";

const root = createPath("/", {});

const locationSelector = root.append("/location-selector", {});

const featureFlags = root.append("/feature-flags", {});

const selectVisit = root.append("/select-visit", {});

const selectActiveVisit = root.append("/select-active-visit", {});

const selectVisitConfirm = selectVisit.append("/confirm/:patientId/:visitId", {
  patientId: codecs.string,
  visitId: codecs.string,
});

const assignSlot = root.append("/assign-slot/:siteId/:sessionId", {
  siteId: codecs.string,
  sessionId: codecs.string,
});

const checkIn = root.append("/check-in/:patientId/:visitId", {
  patientId: codecs.string,
  visitId: codecs.string,
});

const awaitingConsent = checkIn.append("/awaiting-consent", {});

const counterSign = checkIn.append("/counter-sign-consent", {});

const identityCheck = checkIn.append("/identity-check", {});

const preferredName = checkIn.append("/preferred-name", {});

const immediateRiskAssessment = checkIn.append(
  "/immediate-risk-assessment",
  {}
);

const assignToRoom = checkIn.append("/assign-to-room", {});

const assignToSkinScanner = checkIn.append("/assign-to-skin-scanner", {});
const assignToNoravECGDevice = checkIn.append(
  "/assign-to-norav-ecg-device",
  {}
);

const checkInSuccess = checkIn.append("/success", {});

const manualCheckInConfirmed = checkIn.append("/manual-confirmed", {});

const checkOut = checkIn.append("/checkout", {});

// The scan-progress checkout gets its own confirm/confirmed pair, mirroring
// check-in's. It is deliberately not `checkOut` above: that screen also calls
// complete-visit, which the backend rejects for base scans, and routing body
// scans into it would start generating those 400s (AB#92438, see #88682).
const checkOutConfirm = checkIn.append("/checkout-confirm", {});

const checkOutConfirmed = checkIn.append("/checkout-confirmed", {});

const followUpDerma = checkIn.append("/follow-up-derma", {});

const followUpEcg = checkIn.append("/follow-up-ecg", {});

const assignToNoravECGDeviceFollowUp = checkIn.append(
  "/assign-to-norav-ecg-device-follow-up",
  {}
);

const nekoLensAuth = checkIn.append("/neko-scope-auth", {});

const assignVials = checkIn.append("/assign-vials", {});

const drawConfirmation = checkIn.append("/draw-confirmation", {});

// Blood draw confirmation is one screen with two ways in, and each way in needs
// a different footer button, so it gets two paths (AB#92614):
//
//   .../draw-confirmation       opened from the scan progress list
//                               -> button says "Back"
//   .../draw-confirmation-step  reached in the flow after the skin scanner
//                               -> button says "Skip blood draw for now"
//
// The second one is `-step`, not `/step`, on purpose. StepFlow shows every step
// whose path matches the current URL, and `.../draw-confirmation` matches
// `.../draw-confirmation/step` as well. So a child path would show both steps
// at once: the screen mounts twice and runs two barcode scanners.
// Guarded by routes/__tests__/drawConfirmationSteps.test.ts.
const drawConfirmationStep = checkIn.append("/draw-confirmation-step", {});

export const paths = {
  featureFlags,
  identityCheck,
  manualCheckInConfirmed,
  assignToRoom,
  assignToSkinScanner,
  assignToNoravECGDevice,
  assignVials,
  drawConfirmation,
  drawConfirmationStep,
  assignToNoravECGDeviceFollowUp,
  checkInSuccess,
  root,
  awaitingConsent,
  counterSign,
  assignSlot,
  preferredName,
  immediateRiskAssessment,
  checkOut,
  checkOutConfirm,
  checkOutConfirmed,
  followUpDerma,
  followUpEcg,
  locationSelector,
  nekoLensAuth,
  selectVisit,
  selectActiveVisit,
  selectVisitConfirm,
  checkIn,
};
